import { render, staticRenderFns } from "./AboutMeitav.vue?vue&type=template&id=3fd281df&scoped=true"
import script from "./AboutMeitav.vue?vue&type=script&lang=js"
export * from "./AboutMeitav.vue?vue&type=script&lang=js"
import style0 from "./AboutMeitav.vue?vue&type=style&index=0&id=3fd281df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd281df",
  null
  
)

export default component.exports